export function briefyActionStatus(result) {
  if(result && result.ok===true && !result.error) return 'success';
  if(result && result.ok===false && !result.unconfirmed) return 'failed';
  return 'unconfirmed';
}
export function safeBriefyLink(value) {
  if(typeof value!=='string' || !value.startsWith('/') || value.startsWith('//') || /[\\\s]/.test(value))return null;
  try {const parsed=new URL(value,'https://briefcase.invalid');return parsed.origin==='https://briefcase.invalid'?value:null;}catch{return null;}
}
export function parseBriefyResponse(value) {
  if(!value || typeof value.reply!=='string' || !value.reply.trim())throw new Error('Unconfirmed assistant response');
  return {
    reply:value.reply,
    session_id:typeof value.session_id==='string'?value.session_id:'',
    suggestions:Array.isArray(value.suggestions)?value.suggestions.filter(v=>typeof v==='string' && v.trim()).slice(0,8):[],
    actions:Array.isArray(value.actions)?value.actions.filter(a=>a && typeof a.tool==='string').map(a=>({...a,result:a.result && typeof a.result==='object' && !Array.isArray(a.result)?a.result:{}})):[],
  };
}
